import useJwt from '@/auth/jwt/useJwt'

export default class SusiService {
  static get(userId, field) {
    return useJwt.get(`/susi/${field}/${userId}`)
  }

  static getConfigHashes() {
    return useJwt.get('/susi/get-config-hashes')
  }

  static byPrompt(prompt, replaces, conversationId = null) {
    return useJwt.post('/susi/by-prompt', {}, {
      prompt,
      replaces,
      conversation_id: conversationId,
    })
  }

  static chatWithAssistant(conversationId, assistantId, message) {
    return useJwt.post('/susi/chat-blank', {}, {
      conversation_id: conversationId,
      assistant_id: assistantId,
      message,
    })
  }

  static chatWithClaude(message, model = '') {
    return useJwt.post('/susi/claude-text', {}, {
      message,
      model,
    })
  }
}
